import Vue from 'vue';
export const ShipmentEventBus = new Vue();
